import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSizeString',
  standalone: true
})
export class FileSizeStringPipe implements PipeTransform {
  transform(size?: number | null): string {
    if (!size) return '0 KB';
    const sizeInKB = size / 1024;

    // Uses the following rounding rules:
    //   File sizes ≥ 1024 KB are shown in MB to two decimal places (e.g., 2.31 MB)
    //
    //   File sizes < 1024 KB are shown in KB rounded to the nearest whole number (e.g., 524 KB)

    if (sizeInKB >= 1024) {
      const sizeInMB = sizeInKB / 1024;
      return `${sizeInMB.toFixed(2)} MB`;
    } else {
      return `${Math.round(sizeInKB)} KB`;
    }
  }
}
